var _styled;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT, SPACING } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledListItem = styled('li')((_styled = {
  fontFamily: NTA_LIGHT,
  fontWeight: 400,
  textTransform: 'none',
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14,
  width: '100%'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16,
  marginBottom: SPACING.SCALE_1
}, _styled));

var ListItem = function ListItem(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React.createElement(StyledListItem, {
    className: className
  }, children);
};

ListItem.defaultProps = {
  className: undefined
};
ListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(ListItem);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/list-item/es/index.js
// module id = 26
// module chunks = 0